<ng-container >
  <section class="myaccount_header container-fluid">
    <div class="clearfix text-right">
      <h2>{{title | translate}}</h2>
      <!-- <div class="pull-right userDetails">
        <span class="myacc-username" *ngIf="userDetails !== undefined ">{{userDetails.firstName | titlecase}}</span>
        <span class="myacc-playerId" *ngIf="userDetails !== undefined ">{{userDetails.nickname}}</span>
      </div> -->
    </div>
  </section>
</ng-container>

<!-- <ng-container *ngIf="windowType === 'mobile'">
  <div class="mob_myacc_header">
    <div class="mob_myacc--nav">
      <a href="javascript:void(0)" (click)="goToAllGames()">{{'headerComp.games' | translate}}</a>
      <a href="javascript:void(0)" (click)="doDeposit()">{{'headerComp.depositBtn' | translate}}</a>
    </div>
    <section class="mob_userInfo_details clearfix"> -->
      <!-- <div class="mob_userInfo_details--user">
        <div class="mob_userInfo_details--userinfo">
          <span class="myacc-username" *ngIf="userDetails !== undefined ">{{userDetails.firstName | titlecase}}</span>
          <span class="myacc-playerId" *ngIf="userDetails !== undefined ">{{userDetails.nickname}}</span>
        </div>
      </div> -->


      <!-- <div class="account_card" [ngStyle]="{'background-image': 'url(' + siteUrlPath + '/' + mediaUrlPath + '/account-background.png)'}">
        <div class="account_card--title">{{'profileSettingsComp.availableBalance' | translate}}</div>
        <div class="account_card--amount">
          <h2>{{ userService.getUserCashBalance() | currencyPipe}}</h2>
        </div>
        <div class="account_card--bonus">
          <div class="account_card--title">{{'headerComp.bonusBalance' | translate}}</div>
          <h2>{{ userService.getUserBonusBalance() | currencyPipe}}</h2>
        </div>
        <div class="account_card--btns">
          <a class="withdrawBtn-disable" href="javascript:void(0)" *ngIf="!userService.getUserCashBalance()" disabled>{{'cashier.withdrawBtn' | translate}}</a>
          <a href="javascript:void(0)" (click)="doWithdraw()" *ngIf="userService.getUserCashBalance() > 0">{{'cashier.withdrawBtn' | translate}}</a>

          <button class="account_card--btns--deposit" (click)="doDeposit()">
            {{'headerComp.depositBtn' | translate}}
          </button>
        </div>
      </div>
    </section>


    <div class="myaccount-header-row">
      <div class="container-fluid">
        <div class="myaccount-header-btn">
          <div class="myaccount-tabs-list" id="my-account-tabs">
            <button class="btn btn-{{tab.id}}" [ngClass]="{'hide':tab.hide,'active':tab.id===activeMobileTab}"
              *ngFor="let tab of myAccountTabsMobile" (click)="setActiveTab(tab.id)"
              [ngStyle]="{'background-image': tab.id === activeMobileTab ? 'url(' + siteUrlPath + '/' + mediaUrlPath + '/account-icon-background.png)': 'none'}"
              >
              <div class="icon icon--{{tab.id}}-active">
                <img src="{{siteUrlPath}}/{{mediaUrlPath}}/{{tab.activeIcon}}" alt="{{tab.altText}}">
              </div>
              <div class="icon icon--{{tab.id}}">
                <img src="{{siteUrlPath}}/{{mediaUrlPath}}/{{tab.inactiveIcon}}" alt="{{tab.altText}}">
              </div>
              {{tab.name | translate}}

              <ng-container *ngIf="tab.id==='withdrawls'">
                <span class="badge">{{pendingWithDrawsAvailable}}</span>
              </ng-container>
            </button>
          </div>
          <h4 class="mob_myacc_header--title">{{ title | translate}}</h4>
        </div>
        <div class="myaccount-header-row_content">
          <app-complete-profile *ngIf="activeMobileTab === 'myaccount'"></app-complete-profile>
          <app-transaction *ngIf="activeMobileTab === 'transactions'"></app-transaction>
          <app-bet-history *ngIf="activeMobileTab === 'gamehistory'"></app-bet-history>
          <app-bonuses *ngIf="activeMobileTab === 'activebonuses'"></app-bonuses>
        </div>
      </div>
    </div>


  </div>
</ng-container> -->